import Scene from "./components/scene/scene";
import Controls from "./components/controls/controls";

// const HELLO_WORLD_QUERY_KEY = "hello-world";

// const helloWorldSchema = z.object({
//   message: z.string(),
//   timestamp: z.string().optional(),
// });

// async function fetchHelloWorld() {
//   return api.get({
//     url: "hello",
//     schema: helloWorldSchema,
//   });
// }

// export async function clientLoader() {
//   // try {
//   //   const initialData = await fetchHelloWorld();
//   //   queryClient.setQueryData([HELLO_WORLD_QUERY_KEY], initialData);
//   //   return null;
//   // } catch (error) {
//   //   return onPrefetchError(error);
//   // }
// }

// const places = [
//   { id: 1, title: "Москва, Варшавское шоссе, 139" },
//   { id: 2, title: "Чертяново Южное" },
//   { id: 3, title: "Криворожский проезд, 1с1" },
//   { id: 4, title: "Межвидская волость" },
// ];

export default function HomePage() {
  return (
    <>
      <Controls />
      <Scene />
    </>
  );
}
